import { useState, useEffect } from 'react';
import { db } from './firebase';
import { collection, doc, setDoc, getDocs } from 'firebase/firestore';

const LoyaltyManagement = ({ user }) => {
  const [rewards, setRewards] = useState([]);
  const [newReward, setNewReward] = useState({
    name: '',
    pointsRequired: '',
    description: ''
  });

  useEffect(() => {
    if (user) {
      fetchRewards();
    }
  }, [user]);

  const fetchRewards = async () => {
    const snapshot = await getDocs(collection(db, 'loyaltyRewards'));
    const rewardList = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    setRewards(rewardList);
  };

  const saveReward = async () => {
    if (!user || !user.email.endsWith('@kactuskwenchers.com')) {
      alert('Unauthorized');
      return;
    }
    const rewardData = {
      name: newReward.name,
      pointsRequired: parseInt(newReward.pointsRequired) || 0,
      description: newReward.description,
      createdAt: new Date()
    };
    await setDoc(doc(db, 'loyaltyRewards', newReward.name.toLowerCase().replace(/\s/g, '_')), rewardData);
    setNewReward({ name: '', pointsRequired: '', description: '' });
    fetchRewards();
  };

  return (
    <div>
      <h2>Loyalty Program Management</h2>
      <div className="inventory-section">
        <h3>Add New Reward</h3>
        <div className="inventory-form">
          <input
            value={newReward.name}
            onChange={e => setNewReward({ ...newReward, name: e.target.value })}
            placeholder="Reward Name (e.g., Free Drink)"
          />
          <input
            value={newReward.pointsRequired}
            onChange={e => setNewReward({ ...newReward, pointsRequired: e.target.value })}
            placeholder="Points Required"
            type="number"
          />
          <input
            value={newReward.description}
            onChange={e => setNewReward({ ...newReward, description: e.target.value })}
            placeholder="Description"
          />
        </div>
        <div className="inventory-form-buttons">
          <button className="save-button" onClick={saveReward}>
            Add Reward
          </button>
        </div>
      </div>
      <h3>Existing Rewards</h3>
      {rewards.length === 0 ? (
        <p>No rewards found.</p>
      ) : (
        <div className="inventory-grid">
          {rewards.map(reward => (
            <div key={reward.id} className="inventory-card">
              <h4>{reward.name}</h4>
              <p>Points Required: {reward.pointsRequired}</p>
              <p>Description: {reward.description}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LoyaltyManagement;
